import { investorRelationsToTableParser } from 'shared/parsers';

import { GET_INVESTOR_RELATIONS_FINISHED, GET_INVESTOR_RELATIONS } from './investorActions';

const initialState = {
  isPending: false,
  relations: [],
  shouldRefresh: { value: false, reason: null },
  total: 0,
};

export function investor(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_INVESTOR_RELATIONS:
      return { ...state, isPending: true, shouldRefresh: initialState.shouldRefresh };
    case GET_INVESTOR_RELATIONS_FINISHED: {
      const parsedData = investorRelationsToTableParser(payload);
      return { ...state, isPending: false, relations: parsedData, total: payload.length };
    }
    default:
      return state;
  }
}
